import Checkbox from '../../Checkbox/Checkbox';
import classes from './CheckboxWithLabel.module.css';

interface props {
  readonly value: boolean
  readonly setValue: Function
  readonly className?: string
  readonly children: JSX.Element | Array<JSX.Element>
}
export default function CheckboxWithLabel({
  value,
  className,
  setValue,
  children,
}: props) {
  return (
    <div className={`${classes.container} ${className || ''}`} onClick={()=>setValue(!value)}>
      <Checkbox value={value} checked={value} />
      <div className={classes.labelContainer}>
        {children}
      </div>
    </div>
  );
}
